import BrowserLogger from 'alife-logger';
import { GAME_ARMS } from '@/config/constant';

const NODE_ENV = process.env.NODE_ENV || 'development';

/**
 * 获取时间戳
 * @returns {String} 时间戳
 */
export const getTimeStamp = () => {
  const today = new Date();
  const year = today.getFullYear();
  let month = today.getMonth() + 1;
  month = month < 10 ? '0' + month : month;
  let day = today.getDate();
  day = day < 10 ? '0' + day : day;
  let hour = today.getHours();
  hour = hour < 10 ? '0' + hour : hour;
  const minute = today.getMinutes();
  const sec = today.getSeconds();
  // const timeStamp = year + "" + month + "" + day + "" + hour + "" + minute + "" + sec;
  const timeStamp = `${year}${month}${day}${hour}${minute}${sec}`;
  return timeStamp;
};

export const getDiffTime = (date) => {
  const diffTime = new Date(date)
  const nowTime = new Date()
  const restSec = diffTime.getTime() - nowTime.getTime()
  return {
    day: parseInt(restSec / (60 * 60 * 24 * 1000)),
    hour: parseInt(restSec / (60 * 60 * 1000) % 24),
    minute: parseInt(restSec / (60 * 1000) % 60),
    second: parseInt(restSec / 1000 % 60)
  }
}

/**
 * 获取随机数
 * @returns {String} 时间戳
 */
export const getRandomString = () => {
  return Math.random().toString(36).slice(2);
};

/**
 * 微信浏览器
 * @returns
 */
export const wechatBrowser = () => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.match(/Micromessenger/i) && ua.match(/Micromessenger/i)[0] === 'micromessenger';
};

/**
 * 解析url上的参数 转成对象
 */
export const analysisParams = (url) => {
  const params = {};
  const paramsString = url.split('?')[1];
  if (!paramsString) {
    return params;
  }
  const str = paramsString.split('&');
  for (let idx = 0; idx < str.length; idx++) {
    const values = str[idx].split('=');
    params[values[0]] = values[1];
  }
  return params;
};

/**
 * 字符替换
 */
const formatString = (string, regStr, reqStr) => {
  const reg = new RegExp(regStr, 'g');
  return string.replace(reg, reqStr);
};

// 处理特殊的样式值
const supplementStyle = (key, val) => {
  if (key === 'background-image' && val !== 'none') {
    return `url(${val})`;
  }
  return val;
};

/**
 * css属性转成行内样式
 */
export const transformStyle = (cssData = {}) => {
  const supportAttrs = ['width', 'height', 'background_image', 'margin', 'top', 'left', 'right', 'bottom'];
  const style = supportAttrs.reduce((result, attr) => {
    if (!cssData[attr]) {
      return result;
    }
    const key = formatString(attr, '_', '-');
    const value = supplementStyle(key, cssData[attr]);
    result += `${key}: ${value}; `;
    return result;
  }, '');
  return `${cssData.style || ''}${style}`;
};

/**
 * 获取html上的fontSize
 */
export const getHtmlFontSize = () => {
  const fontSize = document.getElementsByTagName('html')[0].style.fontSize;
  return Number(fontSize.replace(/px/img, ''));
};

/**
 * ARMS 埋点
 */
export const buriedLogger = (gameName, pageName) => {
  const pid = GAME_ARMS[gameName].pid;
  return BrowserLogger.singleton({
    pid,
    appType: 'web',
    disabled: NODE_ENV === 'development',
    environment: NODE_ENV === 'development' ? 'local' : 'prod',
    imgUrl: 'https://arms-retcode.aliyuncs.com/r.png?',
    sendResource: true,
    enableLinkTrace: true,
    behavior: true,
    page: pageName
  });
};

/**
 * 监测当前设备
 */
export const monitoringOs = () => {
  const os = function () {
  const ua = navigator.userAgent,
    isWindowsPhone = /(?:Windows Phone)/.test(ua),
    isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox &&
      /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isSymbian;
    return {
      isTablet: isTablet,
      isPhone: isPhone,
      isAndroid: isAndroid,
      isPc: isPc
    };
  }();
  if (os.isAndroid || os.isPhone) {    
    if(os.isAndroid) {
      return 'android'
    } else {
      return 'ios'
    }
  } else if (os.isTablet) {
    return 'tablet'
  } else if (os.isPc) {
    return 'pc'
  }
}

/**
 * 获取下手机屏幕的数据
 */
export const getPhoneParams = () => {
  var h = "";
  h = `
    网页可见区域宽：${document.body.clientWidth}(client) \n\r
    网页可见区域高：${document.body.clientHeight} \n\r
    网页可见区域宽：${document.body.offsetWidth}(offset) \n\r
    网页可见区域高：${document.body.offsetHeight} \n\r
    网页正文全文宽：${document.body.scrollWidth} \n\r
    网页正文全文高：${document.body.scrollHeight} \n\r
    网页被卷去的上：${document.body.scrollTop} \n\r
    网页被卷去的左：${document.body.scrollLeft} \n\r
    网页正文部分上：${window.screenTop} \n\r
    网页正文部分左：${window.screenLeft} \n\r
    屏幕分辨率的宽：${window.screen.width} \n\r
    屏幕分辨率的高：${window.screen.height} \n\r
    屏幕可用工作区宽度：${window.screen.availWidth} \n\r
    屏幕可用工作区高度：${window.screen.availHeight} \n\r
  `
  return h
}


// WEBPACK FOOTER //
// ./src/utils/utils.js